import React from 'react'
import {Typography, withStyles} from '@material-ui/core';
import style from './style'

const PaymentResult = ({className, classes, success, subtitle = undefined}) => {
    const topImg = success ? "successImg.svg" : "errorImg.svg"
    const title = success ? "¡Compra exitosa!" : "Algo salió mal"
    subtitle = subtitle || (success
        ? "Su operación ha sido procesada satisfactoriamente"
        : "No se ha podido concretar el pago")

    return (
        <div className={`${classes.wrapper} ${className}`}>
            <div>
                <img alt="" src={`${window.env.ASSETS_URL}/images/templates/${topImg}`} id="resultLogo" />
            </div>
            <Typography component={"p"} className={`${classes.title} ${success ? "" : "error"}`}
                        variant="body1" id="resultMessage">{title}</Typography>
            <Typography className={classes.subtitle} variant="body1" id="resultDescription">{subtitle}</Typography>
        </div>
    )
}

export default withStyles(style)(PaymentResult)
